export {
  getNowPlayingMovies as NowPlaying,
  getPopularMovies as PopularMovies,
  getByGenre as ByGenre,
  getSearchResults as SearchResults,
} from "./getMovies";
export { loginUser, registrationUser } from "./loginLogic";
